import _ from 'lodash';

export default class UpdateWebhook {
  constructor(context) {
    this.context = context;
  }

  run(webhook) {
    _.forEach(this.context.stores.webhooks.getAllErrors(), (val, webhookId) => {
      this.context.stores.webhooks.clearErrors(webhookId);
    });
    this.context.gateways.webhook.update({ webhookId: webhook.id }, webhook);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/integrations/webhooks/update_webhook.js